export default __webpack_public_path__ + "static/media/field.8d9d2116.png";